import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Features from "@/components/landing/Features";
import Showcase from "@/components/landing/Showcase";
import HowItWorks from "@/components/landing/HowItWorks";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import ScrollProgress from "@/components/landing/ScrollProgress";
import CursorGlow from "@/components/landing/CursorGlow";
import Marquee from "@/components/landing/Marquee";

export default function LandingPage() {
    return (
        <div data-testid="landing-page" className="relative bg-[#0a0a0c] text-[#f5f5f7] font-body overflow-x-hidden">
            <ScrollProgress />
            <CursorGlow />
            <Navbar />
            <main>
                <Hero />
                <Features />
                <Marquee />
                <Showcase />
                <HowItWorks />
                <FAQ />
            </main>
            <Footer />
        </div>
    );
}
